module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/access-c73d6329a4c3d90cd1320d53afb38e73.svg";